﻿import { Circle as CircleStyle, Icon, Fill, Stroke, Style, Text } from 'ol/style.js';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import Collection from 'ol/Collection.js';
export { NavisionTool };

/**
 * Class RoadBuilderTool
 */
const NavisionTool = function () {

    // Define this
    var myNavisionTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    // Already initialize
    this._toolInitialize = false;

    this._idClient = "";

    this.ShowAllClient = function (ramalId, data) {

        $('.header-navision-ramal-id').html('Ramal ' + ramalId);

        $('#offcanvas-navision-body div').remove();

        for (var i = 0; i < data.result.length; i++) {

            if ($('#offcanvas-navision-body .morada-div').length == 0) {

                $('#offcanvas-navision-body').append('<div class="col-md-12 form-group morada-div" style="padding-left:0px; padding-right:0px;">' +
                    '<label>Morada</label>' +
                    '<textarea rows="2" class="col-md-12 form-control" type="text" value="" readonly>' + data.result[i].morada + '</textarea></div>');
            }



            for (var e = 0; e < data.result[i].estados.length; e++) {

                var CountEstado = data.result[i].resultados.filter(c => c.estado == data.result[i].estados[e]).length;

                $('#offcanvas-navision-body').append('<div id="div-result' + data.result[i].codPredio + '-navision-body-' + data.result[i].estados[e] + '" class="option-title-collapse option-title-row-navision">' +
                    '<i class="fa option-title-go-right-open option-title-open-client-result fa-chevron-down"></i>' +
                    '<label class="option-title-label-theme">' + data.result[i].estados[e] + ' ' + CountEstado + '/' + data.result[i].countTotal + '</label></div>' +
                    '<div class="modal-border-style-GP"></div>');

            }

            for (var ii = 0; ii < data.result[i].resultados.length; ii++) {

                $('#div-result' + data.result[i].codPredio + '-navision-body-' + data.result[i].resultados[ii].estado + '').append('<div id="' + data.result[i].resultados[ii].numcliente + '" class="option-title-collapse" style="display: none;"> ' +
                    '<i class="fa option-title-go-right-open option-title-open-client-result fa-chevron-down"></i>' +
                    '<i class="fa option-title-go-left-open fa-user"></i><label class="option-title-label-theme" style="margin-left: 10px;">' + 'Habitação ' + data.result[i].resultados[ii].morada.fracao + '</label></div>');

                $('#id-template-navision').clone().appendTo('#' + data.result[i].resultados[ii].numcliente);

                myNavisionTool._idClient = '#' + data.result[i].resultados[ii].numcliente;


                $.each(data.result[i].resultados[ii], function (index, value) {

                    if (index != "nome") {

                        $(myNavisionTool._idClient + ' .' + index).val(value);
                    }

                });

                $(myNavisionTool._idClient + ' .morada').val(data.result[i].resultados[ii].morada.rua + ' ' + data.result[i].resultados[ii].morada.porta + ' ' + data.result[i].resultados[ii].morada.fracao);

                //if (data.result[i].resultados[ii].contacto.telefone) {
                //    $(myNavisionTool._idClient + ' .telefone').parent('div').css({ 'display': 'block' });
                //    $(myNavisionTool._idClient + ' .telefone').val(data.result[i].resultados[ii].contacto.telefone);
                //} else
                //    $(myNavisionTool._idClient + ' .telefone').parent('div').css({ 'display': 'none' });

                //if (data.result[i].resultados[ii].contacto.email) {
                //    $(myNavisionTool._idClient + ' .email').parent('div').css({ 'display': 'block' });
                //    $(myNavisionTool._idClient + ' .email').val(data.result[i].resultados[ii].contacto.email);
                //} else
                //    $(myNavisionTool._idClient + ' .email').parent('div').css({ 'display': 'none' });

            }

        }

        $('.option-title-open-client-result').off('click').on('click', function () {

            $(this).siblings('div').toggle('ol-hidden');

        });

        $('.web-service-tooltip').children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');

        myNavisionTool._mapSgs._utility.ShowOpenCanvas3('offcanvas-navision', true);

    }

    // Get Client by Ramal
    this.getAllClientByRamal = function () {

        $('.web-service-tooltip').off('click').on('click', function () {

            if ($('.web-service-tooltip').hasClass('fas fa-spinner fa-spin')) {
                return
            }

            $('.web-service-tooltip').children('i').removeClass('fa-home').addClass('fas fa-spinner fa-spin');

            var ramalId = this.id;

            $.ajax({
                type: 'GET',
                url: '/rest/app/NavisionTool/GetClientWebService?Cod_Ramal=' + ramalId,
                async: true,
                dataType: "json",
                contentType: "application/json;",
                success: function (data) {
                    if (data.error) {
                        toastr["error"]("Erro ao carregar clientes associados");
                    }
                    else {
                        if (data.result != null && data.result.length > 0) {

                            myNavisionTool.ShowAllClient(ramalId, data)

                        } else {
                            $('#offcanvas-navision-body div').remove();
                            if (data.result !== undefined && data.result.res !== undefined) {
                                toastr["error"]("Erro no acesso a informação");
                            }
                            else {
                                toastr["warning"]("Nenhum cliente associado");
                            }
                            $('.web-service-tooltip').children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');
                        }

                    }
                },
                error: function (request, status, error) {
                    $('.web-service-tooltip').children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');
                }
            });

        });

    }
   
    /**
     * Get Client by Ramal
     * @param {any} idButton
     */
    this.getAllClientByPredio = function (idButton) {

        $('.' + idButton).off('click').on('click', function ()
        {
            var thisBtn = this;

            if ($(thisBtn).hasClass('fas fa-spinner fa-spin')) {
                return;
            }

            $(thisBtn).children('i').removeClass('fa-home').addClass('fas fa-spinner fa-spin');

            var codPredio = this.id.split('cod_')[1];

            if (codPredio == "null") {
                toastr["warning"]("Informação de código de prédio em falta");
                $(thisBtn).children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');

                return;
            }

            if (!codPredio) {
                codPredio = this.closest('tr').id;
            }

            $.ajax({
                type: 'GET',
                url: '/rest/app/NavisionTool/GetClientWebServiceByPredio?cod_Predio=' + codPredio,
                async: true,
                dataType: "json",
                contentType: "application/json;",
                success: function (data)
                {
                    if (data.error) {
                        toastr["error"]("Erro ao carregar clientes associados");
                    }
                    else {
                        if (data.result != null && data.result.length > 0) {

                            myNavisionTool.ShowAllClient(codPredio, data)

                            $(thisBtn).children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');

                        } else {
                            if (data.result !== undefined && data.result.res !== undefined) {
                                toastr["error"]("Erro no acesso a informação");
                            }
                            else {
                                toastr["warning"]("Nenhum cliente associado");
                            }
                            $(thisBtn).children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');
                        }
                    }
                },
                error: function (request, status, error) {
                    $(thisBtn).children('i').removeClass('fas fa-spinner fa-spin').addClass('fa-home');
                }
            });
        });
    }

};

/**
 * Init railway tool
 * @param {object} mapSgs, map object
 */
NavisionTool.prototype.Init = function (mapSgs) {

    // Keep map sgs
    this._mapSgs = mapSgs;

};